import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sales-company',
  templateUrl: './sales-company.component.html',
  styleUrls: ['./sales-company.component.css']
})
export class SalesCompanyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
